<template>
    <section>
        <div class="d-flex justify-content-between align-items-center">
            <span class="text-left">IP Address: {{value.IPAddress}}</span>
            <b-btn size="sm" variant="warning" @click="print">
                Print
            </b-btn>
        </div>
    </section>
</template>

<script>
    import JSPM from "jsprintmanager";
    import moment from "moment";
    var cptable = require('codepage');
    export default {
        name: "printReport",
        props: {
            value: {
                type: Object,
                required: true
            },
            result: {
                required: true
            },
            serverIp: {
                required: false
            }
        },
        computed: {
          getData () {
              return this.result
          }
        },
        methods: {
            convertDate (date, noTime) {
                moment.locale('en');
                if (noTime) {
                    return date && moment(date).format('D MMM YY')
                } else {
                    return date && moment(date).format('D MMM YY - hh:mm A')
                }
            },
            currencyDisplay (value) {
                if (value === 0) {
                    return '$' + '0.00'
                } else {
                    return '$' + value.toFixed(2)
                }
            },
            jspmWSStatus () {
                if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
                    return true;
                else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
                    return false;
                }
                else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
                    return false;
                }
            },
            print () {
                if (this.jspmWSStatus()) {
                    let cpj = new JSPM.ClientPrintJob();
                    cpj.clientPrinter = new JSPM.NetworkPrinter(9100, this.value.IPAddress)
                    var esc = '\x1B'; //ESC byte in hex notation
                    var newLine = '\x0A'; //LF byte in hex notation

                    var cmds = esc + '@'; //Initializes the printer (ESC @)
                    cmds += esc + '\x02'
                    this.getData.forEach(item => {
                        cmds += newLine
                        cmds += item.RestaurantName
                        cmds += newLine
                        cmds += 'Server Shift report'
                        cmds += newLine
                        cmds += 'For ' + this.convertDate(item.OrderDate, 'noTime')
                        cmds += newLine
                        cmds += 'Server: ' + item.ServerName
                        cmds += newLine
                        cmds += 'Created on: ' + this.convertDate(item.CreateDate)
                        cmds += newLine + newLine + newLine
                        cmds += 'Total Gross Sales (Subtotals): ' + this.currencyDisplay((item.Gross_Sale))
                        cmds += newLine
                        cmds += 'Food & Non-Alcoholic Drinks: ' + this.currencyDisplay((item.Gross_Sale_NAL_Drink) + item.Gross_Sale_Food)
                        cmds += newLine
                        cmds += 'Alcoholic Drinks: ' + this.currencyDisplay((item.Gross_Sale_AL_Drink))
                        cmds += newLine + newLine + newLine

                        cmds += 'Total Credit Applied: ' + this.currencyDisplay((item.Credits))
                        cmds += newLine
                        cmds += 'Total Voids: ' + this.currencyDisplay(item.Voids)
                        cmds += newLine
                        cmds += 'Total Refunds: ' + this.currencyDisplay(item.Refunds)
                        cmds += newLine + newLine + newLine

                        cmds += 'Total Net Sales (Subtotals after credit): ' + this.currencyDisplay((item.Net_Sale))
                        cmds += newLine
                        cmds += 'Food & Non-Alcoholic Drinks: ' + this.currencyDisplay((item.Net_Sale_NAL_Drink) + (item.Net_Sale_Food))
                        cmds += newLine
                        cmds += 'Alcoholic Drinks: ' + this.currencyDisplay((item.Net_Sale_AL_Drink))
                        cmds += newLine + newLine + newLine


                        cmds += 'Total Tax: ' + this.currencyDisplay((item.Taxes))
                        cmds += newLine
                        cmds += 'Food & Non-Alcoholic Drinks: ' + this.currencyDisplay((item.Tax_Food_NAL_Drink))
                        cmds += newLine
                        cmds += 'Alcoholic Drinks: ' + this.currencyDisplay((item.Tax_Alc_Drink))
                        cmds += newLine + newLine + newLine

                        cmds += 'Total Tip: ' + this.currencyDisplay(item.Tips)
                        cmds += newLine
                        cmds += 'Card: ' + this.currencyDisplay(item.Tip_Card)
                        cmds += newLine
                        cmds += 'Cash: ' + this.currencyDisplay(item.Tip_Cash)
                        cmds += newLine + newLine + newLine

                        cmds += 'Total Payments Received: ' + this.currencyDisplay((item.Paymeny_Received))
                        cmds += newLine
                        cmds += 'Card: ' + this.currencyDisplay((item.Paymeny_Received_Card))
                        cmds += newLine
                        cmds += 'Cash: ' + this.currencyDisplay((item.Paymeny_Received_Cash))
                        cmds += newLine + newLine + newLine


                        cmds += 'Tip Out to House: ' + this.currencyDisplay((item.Tip_Outhouse))
                        cmds += newLine
                        cmds += 'Cash Owed to House: ' + (item.Server_Balance <= 0 ? Math.abs(item.Server_Balance) : '')
                        cmds += newLine
                        cmds += 'Money Owed to Sever: ' + (item.Server_Balance > 0 ? Math.abs(item.Server_Balance) : '')
                        cmds += newLine + newLine + newLine


                        cmds += 'Number of Tabs: ' + item.No_Of_Tabs
                        cmds += newLine
                        cmds += 'Average Tab Amount (Gross Sales): ' + this.currencyDisplay((item.Avg_Tab_Amount))
                        cmds += newLine
                        cmds += 'Average Tip Percentage: ' + (item.Avg_Tip_Percent !== 0 ? item.Avg_Tip_Percent.toFixed(2) : '0')
                        cmds += newLine
                        cmds += 'Served Tab Nos: ' + item.Serverd_Tabs
                        cmds += newLine + newLine

                        cmds += 'Note: Sales numbers are rouned to the nearest'
                        cmds += newLine
                        cmds +='cent and may vary slightly from report to report.'
                        cmds += newLine + newLine + newLine
                        cmds += '\x1D' + '\x56' + '\x41' + '0'
                    })

                    console.log(cmds)

                    cpj.printerCommands = cmds;

                    cpj.sendToClient();
                    this.$emit('printStatus', {
                        success: true,
                        message: 'Print Successfully'
                    })
                } else {
                    if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
                        this.$emit('printStatus', {
                            success: false,
                            message: 'JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm'
                        })
                    }
                    else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked){
                        this.$emit('printStatus', {
                            success: false,
                            message: 'JSPM has blocked this website!'
                        })
                    }
                    else {
                        this.$emit('printStatus', {
                            success: false,
                            message: 'WebSocket connection to ' + this.serverIp + ' failed'
                        })
                    }
                }
            },

        }
    }
</script>

<style scoped>

</style>
